import { useMutation, useQueryClient } from 'react-query';
import queryString from 'query-string';

import { api, ENDPOINTS, useToken } from '~/api';

export const useUpdateCustomer = ({ surveyId, customerId }) => {
    const queryClient = useQueryClient();
    const { token } = useToken();

    return useMutation(payload => api.patch(
        `${ENDPOINTS.CUSTOMERS}/?${queryString.stringify({ customerId })}`,
        payload,
        { headers: { Authorization: token } }
    ), {
        onSuccess: () => {
            queryClient.invalidateQueries(`${ENDPOINTS.CUSTOMERS}/?surveyId=${surveyId}`);
        },
    });
};
